// TASK-683 — tells the shared widget chrome which widget it is wrapping.
//
// `WidgetContainer` lives INSIDE each widget, so it cannot see the spec that summoned it.
// `WidgetRenderer` can, and provides it here — one provider instead of threading two props
// through all 33 widget adapters (and every widget added after this one).
//
// Outside the canvas (a widget rendered directly on a page) the context is simply absent and
// the chrome falls back to its no-derivation state, which is the truth in that case.
import { createContext, useContext, type ReactNode } from 'react';

export interface WidgetProvenanceContext {
  /** Registry name of the widget being rendered, e.g. "DnaCard". */
  component: string;
  /** The client the widget was scoped to, when it is client-scoped. */
  clientId?: string;
}

const Ctx = createContext<WidgetProvenanceContext | null>(null);

export function WidgetProvenanceProvider({
  component,
  clientId,
  children,
}: WidgetProvenanceContext & { children: ReactNode }) {
  return <Ctx.Provider value={{ component, clientId }}>{children}</Ctx.Provider>;
}

export function useWidgetProvenance(): WidgetProvenanceContext | null {
  return useContext(Ctx);
}
